import { Component, OnInit, Renderer2 } from '@angular/core';
import {
  ActivatedRoute,
  Data,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CoreModule } from './@core/core.module';

import { filter, map } from 'rxjs';
import { BreadCrumbServiceRight } from './@AppService/Services/breadcrumbserviceRight';
import { LoadingComponent } from './@theme/layout/components/loader/loading.component';
import { CookiesBannerComponent } from './@core/shared/Components/cookies-banner/cookies-banner.component';
import {
  ITabTitle,
  TabTitleService,
} from './@AppService/Services/tabTitle.service';
import { MuneerService } from './@AppService/Services/muneer.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CoreModule, LoadingComponent, CookiesBannerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  direction: string = 'rtl';
  constructor(
    private translate: TranslateService,
    private breadCrumbService: BreadCrumbServiceRight,
    private tabTitleService: TabTitleService,
    private router: Router,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private muneerService: MuneerService
  ) {
    // translate.setDefaultLang('ar');
  }

  ngOnInit() {
    this.setInitialLanguageAndDirection();
    this.getRouterData();
    this.translate.onLangChange.subscribe((lang) => {
      if (lang.lang == 'ar') {
        this.direction = 'rtl';
      } else {
        this.direction = 'ltr';
      }
    });

    this.changeFavicon('assets/images/favicon.png'); // Update with your new icon path

    // Register image caching service worker
    if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw-image-cache.js').catch((err) => {
        console.error('Image cache SW registration failed:', err);
      });
    }
  }

  ngAfterViewInit(): void {
    this.muneerService.loadMuneerScript();
    // this.muneerService.muneerOptions.closeButton = false;

    // this.muneerService.updateMuneerOption;
    // this.muneerService.updateMuneerOption('', '');
  }
  // changeFavicon(iconUrl: string) {
  //   const link: HTMLLinkElement =
  //     document.querySelector("link[rel*='icon']") ||
  //     this.renderer.createElement('link');
  //   link.type = 'image/x-icon';
  //   link.rel = 'shortcut icon';
  //   link.href = iconUrl;

  //   this.renderer.appendChild(document.head, link);
  // }

  changeFavicon(iconUrl: string) {
    const timestamp = new Date().getTime();
    const version = '1.2.3'; // أو قيمة جايالك من الـ API
    const finalUrl = `${iconUrl}?v=${timestamp}`;

    // favicon (للتاب في المتصفح)
    let link: HTMLLinkElement | null =
      document.querySelector("link[rel~='icon']");
    if (!link) {
      link = this.renderer.createElement('link');
      this.renderer.appendChild(document.head, link);
    }
    if (link) {
      link.type = 'image/png';
      link.rel = 'icon';
      link.href = finalUrl;
    }

    // apple-touch-icon (لأجهزة iPhone و iPad لما المستخدم يحفظ الموقع على الهوم سكرين)
    let appleIcon: HTMLLinkElement | null = document.querySelector(
      "link[rel='apple-touch-icon']"
    );
    if (!appleIcon) {
      appleIcon = this.renderer.createElement('link');
      this.renderer.appendChild(document.head, appleIcon);
    }
    if (appleIcon) {
      appleIcon.rel = 'apple-touch-icon';
      appleIcon.href = finalUrl;
    }
  }

  private setInitialLanguageAndDirection() {
    // Retrieve language from localStorage or default to 'ar'
    const savedLanguage = localStorage.getItem('language') || 'ar';
    this.translate.use(savedLanguage);
    this.updateDirection(savedLanguage);
  }

  private updateDirection(language: string) {
    this.direction = language === 'ar' ? 'rtl' : 'ltr';
  }

  private getRouterData() {
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        map((e) => getRouterData(this.route))
      )
      .subscribe((data) => {
        this.tabTitleService.pageTitle$.next({} as ITabTitle);
        this.tabTitleService.pageDescription$.next({} as any);
        
        const title = data?.['pageTitle'];
        if (title) {
          this.tabTitleService.pageTitle$.next(title);
        }
        
        const desc = data?.['pageDescription'];
        if (desc) {
          this.tabTitleService.pageDescription$.next(desc);
        }
        
        this.breadCrumbService.updateBreadCrumb(data?.['breadCrumb']);
      });
  }

  title = 'معين للمكتبات الرقمية';
}

export function getRouterData(route: ActivatedRoute): Data {
  let child = route.firstChild;
  if (!child) return route.snapshot.data;
  while (child.firstChild) {
    child = child?.firstChild;
  }
  return child.snapshot.data;
}
